<script setup lang="ts">
import useSubHeaderState from './useSubHeaderState';

/**
 * The Sub Header
 * --------------------------------
 * Used as header bar in subflow pages like upselling
 * - shows breadcrumbs and a back button
 * - horizontally scrollable if too many breadcrumbs
 */

const {
    breadcrumbs,
} = useSubHeaderState();

const scrollbarWidth = ref(0);
onMounted(() => {
    scrollbarWidth.value = window.innerWidth - document.body.clientWidth;
});

const elSwipeOverflow = useTemplateRef('elSwipeOverflow');
watch(breadcrumbs, () => {
    elSwipeOverflow.value?.recalculate();
});
</script>

<template>
    <div class="relative flex h-10 items-center border-b border-b-shade-1 bg-background-2" :style="`width: calc(100vw - ${scrollbarWidth}px);`">
        <BaseSwipeOverflow ref="elSwipeOverflow" start-position="right" slide-class="px-container-gap">
            <div class="flex items-center space-x-2 truncate typo-meta-s-medium">
                <template
                    v-for="(breadcrumb, index) in breadcrumbs"
                    :key="breadcrumb.label"
                >
                    <span v-if="index > 0">/</span>
                    <button

                        class="flex items-center"
                        :class="!!breadcrumb.callback ? 'cursor-pointer underline' : 'cursor-default'"
                        @click="breadcrumb.callback"
                    >
                        <Icon v-if="index === 0" name="tot:caret-left" class="{{ breadcrumb.label }}mr-2 block size-4" />
                        <span class="whitespace-nowrap">{{ breadcrumb.label }}</span>
                    </button>
                </template>
            </div>
        </BaseSwipeOverflow>

        <div class="absolute top-0 left-0 z-10 flex h-full w-container-gap-capped">
            <div class="h-full w-1/3 bg-background-2 bg-linear-to-r" />
            <div class="h-full w-2/3 bg-linear-to-r from-background-2 to-transparent" />
        </div>
        <div class="absolute top-0 right-0 z-10 flex h-full w-container-gap-capped">
            <div class="h-full w-2/3 bg-linear-to-l from-background-2 to-transparent" />
            <div class="h-full w-1/3 bg-background-2 bg-linear-to-l" />
        </div>
    </div>
</template>
